import { storageDateFormat } from '@/core';
import moment from 'moment';
import order from './order';

export default function() {
	return {
		...order(),

		goodsTypeId: undefined,
		customerId: undefined,

		name: '',
		departureTime: undefined,
		arrivalTime: undefined,
		duration: 1,
		generatedOrders: [],
		autoSchedule: false,
		nextOrder: undefined,
		tripTemplateBindings: [],

		frequency: {
			type: '',
			startDate: moment().startOf('day').format(storageDateFormat),
			endDate: '',
			weekly: {
				monday: false,
				tuesday: false,
				wednesday: false,
				thursday: false,
				friday: false,
				saturday: false,
				sunday: false
			},
			twoWeekly: {
				oddWeeks: {
					monday: false,
					tuesday: false,
					wednesday: false,
					thursday: false,
					friday: false,
					saturday: false,
					sunday: false
				},
				evenWeeks: {
					monday: false,
					tuesday: false,
					wednesday: false,
					thursday: false,
					friday: false,
					saturday: false,
					sunday: false
				}
			},
			monthly: [
				{
					number: 1,
					day: 'monday'
				}
			],
			specificDates: []
		}
	};
}
